<template>
  <div id="app">
    <div class="site-header" :class="{ 'mobileopen' : nav }">
        <div class="site-logo">
            <router-link to="/">
                <img alt="Vue logo" src="@/assets/logo-mark.svg">
            </router-link>
            <div class="mobile" @click="toggleNav"></div>
        </div>
        <div class="navigation" v-if="nav">
            <router-link to="/survey">
                <span @click="closeNav">Take the Survey</span>
            </router-link>
            <router-link to="/about">
                <span @click="closeNav">About this Survey</span>
            </router-link>
            <a @click="closeNav" target="_blank" href="http://opensourcejobs.com">Open Source Jobs</a>
            <router-link to="/resources">
                <span @click="closeNav">Resources</span>
            </router-link>
        </div>
    </div>
    <div class="frame">
        <transition
            name="fade"
            mode="out-in">
            <router-view/>
        </transition>
    </div>
  </div>
</template>

<script>

    export default {
        name: "app",
        data(){
            return {
                navopen : false
            }
        },
        methods: {
            toggleNav(){
                this.navopen = !this.navopen
            },
            closeNav(){
                this.navopen = false
            },
            mobile(){
                this.$store.commit( 'mobile', window.innerWidth < 800 )
                this.navopen = false
            }
        },
        computed: {
            nav(){
                return this.navopen || !this.$store.getters.mobile
            }
        },
        beforeMount(){
            this.mobile()
            window.addEventListener( "resize", this.mobile )
        }
    }
    
</script>

<style lang="scss">
    @import "scss/reset";
    @import "scss/vars";
    @import "scss/base";

    $sidebar-size: 200px;

    .mobile{
        width: 4rem;
        height: 4rem;
        background-color: white;
        background-image: url( ~@/assets/hamburger.svg );
        background-size: 50% auto;
        background-repeat: no-repeat;
        background-position: center;
        border-radius: 100%;

        @media screen and (min-width: $b1){
            display: none;
        }
    }

    #app{
        padding-top: 6rem;
        @media screen and (min-width: $b1){
            padding-top: 0;
            margin-left: $sidebar-size;
        }
    }

    .frame{
        padding: 2rem;
        max-width: 1000px;
        margin: 0 auto;
    }

    .site-logo{
        display: flex;
        justify-content: space-between;
        align-items: center;
        background-color: $black;
        padding: 1rem 2rem;

        @media screen and (min-width: $b1){
            display: block;
            background-color: none;
            padding: 0;
        }
        
        a{
            width: 7rem;
            display: block;
            background-color: $black;
            transition: background-color 0.25s ease;

            

            @media screen and (min-width: $b1){
                padding: 4rem 2rem;
                margin: 0 auto;
                width: auto;
                
                &:hover{
                    background: $red;
                }
            }
        }
    }

    .site-header{
        width: 100%;
        z-index: 1000;
        position: fixed;
        left: 0;
        top: 0;

        @media screen and (min-width: $b1){
            width: $sidebar-size;
            background: white;
            bottom: 0;
        }
    }

    .navigation{
        background: white;
        position: absolute;
        left: 0;
        right: 0;

        a{
            display: block;
            text-decoration: none;
            text-transform: uppercase;
            font-weight: 700;
            padding: 2rem;
            border-bottom: 1px solid #eee;
            text-align: center;

            @media screen and (min-width: $b1){
                color: $black;

                &:hover{
                    color: $blue;
                }
            }
        }
    }

    .fade-enter-active,
    .fade-leave-active {
        transition-duration: 0.3s;
        transition-property: opacity;
        transition-timing-function: ease;
    }

    .fade-enter,
    .fade-leave-active {
        opacity: 0
    }
</style>
